import React from 'react';
import { useParams } from 'react-router';

import ActionButton from '@components/button/ActionButton';
import useSingleCompanySync from './_hooks/useSingleCompanySync';

const CompanySingleSync: React.FC = () => {
    const { id } = useParams<ParamType>();
    const { isSyncing, handleSync } = useSingleCompanySync(id);

    return (
        <ActionButton
            color="blue"
            icon={`sync ${isSyncing ? 'fa-spin' : ''}`}
            isPosting={isSyncing}
            onClick={handleSync}
        >
            Sync with Companies House
        </ActionButton>
    );
};

type ParamType = { id: string };

export default CompanySingleSync;
